import { Flex } from "@jsq/ds/core";
import { IconType } from "@jsq/ds/icons";
import { RiskRating as RiskRatingEnum } from "~/graphql/supergraphEnums";
import { RiskRating } from "~/graphql/supergraphTypes";
import { RiskRatingCell } from "~/pages/Compliance/riskRating/RiskRatingCell";
import { RISK_RATING_PROPS } from "../constants";
import { disabledState, riskRatingRendererContainer } from "./styles_vanilla.css";

type Props = {
  riskRating?: RiskRating | null;
  changeIcon?: IconType | null;
  showHoverInspector?: boolean;
  onInspectRiskRating?: () => void;
  isFullWidth?: boolean;
  disabled?: boolean;
};

export const RiskRatingRenderer = ({
  riskRating,
  changeIcon,
  showHoverInspector = false,
  onInspectRiskRating,
  isFullWidth = false,
  disabled = false,
}: Props) => {
  const ratingProps = RISK_RATING_PROPS[riskRating ?? RiskRatingEnum.None];

  return (
    <Flex
      className={`${riskRatingRendererContainer} ${disabledState[disabled ? "disabled" : "default"]}`}
    >
      <RiskRatingCell
        hasIcon={ratingProps.hasIcon}
        iconType={ratingProps.iconType}
        color={ratingProps.color}
        text={ratingProps.text}
        changeIcon={changeIcon}
        showHoverInspector={showHoverInspector}
        onInspectRiskRating={onInspectRiskRating}
        isFullWidth={isFullWidth}
      />
    </Flex>
  );
};
